"use strict";

exports.__esModule = true;
exports.default = _default;

var _Config = require("base-shell/lib/providers/Config");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _reactIosPwaPrompt = _interopRequireDefault(require("react-ios-pwa-prompt"));

var _react = _interopRequireDefault(require("react"));

var _Theme = require("material-ui-shell/lib/providers/Theme");

var _UpdateContainer = _interopRequireDefault(require("material-ui-shell/lib/containers/UpdateContainer/UpdateContainer"));

var _Provider = _interopRequireDefault(require("material-ui-shell/lib/providers/Dialogs/Question/Provider"));

var _theme = _interopRequireDefault(require("material-ui-shell/lib/utils/theme"));

var _notistack = require("notistack");

var _styles = require("@material-ui/core/styles");

var _reactIntl = require("react-intl");

var _Provider2 = _interopRequireDefault(require("material-ui-shell/lib/providers/Filter/Provider"));

var _Provider3 = _interopRequireDefault(require("material-ui-shell/lib/providers/VirtualLists/Provider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(_ref) {
  var children = _ref.children;
  var intl = (0, _reactIntl.useIntl)();

  var _useConfig = (0, _Config.useConfig)(),
      appConfig = _useConfig.appConfig;

  var _useTheme = (0, _Theme.useTheme)(),
      themeID = _useTheme.themeID,
      isDarkMode = _useTheme.isDarkMode,
      isRTL = _useTheme.isRTL;

  var _ref2 = appConfig || {},
      themeConfig = _ref2.theme,
      pwa = _ref2.pwa,
      notistack = _ref2.notistack;

  var _ref3 = pwa || {},
      useiOSPWAPrompt = _ref3.useiOSPWAPrompt,
      iOSPWAPromptProps = _ref3.iOSPWAPromptProps;

  var _ref4 = themeConfig || {},
      _ref4$themes = _ref4.themes,
      themes = _ref4$themes === void 0 ? [] : _ref4$themes;

  var theme = (0, _theme.default)(themeID, themes, isDarkMode, isRTL);
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), /*#__PURE__*/_react.default.createElement(_notistack.SnackbarProvider, _extends({
    maxSnack: 3
  }, notistack), /*#__PURE__*/_react.default.createElement(_UpdateContainer.default, null, /*#__PURE__*/_react.default.createElement(_Provider.default, null, /*#__PURE__*/_react.default.createElement(_Provider2.default, null, /*#__PURE__*/_react.default.createElement(_Provider3.default, null, children))))), useiOSPWAPrompt && /*#__PURE__*/_react.default.createElement(_reactIosPwaPrompt.default //debug={true}
  , _extends({
    promptOnVisit: 1,
    timesToShow: 3,
    copyTitle: intl.formatMessage({
      id: 'ios_prompt_title',
      defaultMessage: 'Add to Home Screen'
    }),
    copyClosePrompt: intl.formatMessage({
      id: 'ios_prompt_close',
      defaultMessage: 'Close'
    }),
    copyBody: intl.formatMessage({
      id: 'ios_prompt_body',
      defaultMessage: 'This website has app functionality. Add it to your home screen to use it in fullscreen and while offline.'
    }),
    copyShareButtonLabel: intl.formatMessage({
      id: 'ios_prompt_share_button',
      defaultMessage: "1) Press the 'Share' button"
    }),
    copyAddHomeButtonLabel: intl.formatMessage({
      id: 'ios_prompt_add_to_home_button',
      defaultMessage: "2) Press 'Add to Home Screen'"
    }),
    permanentlyHideOnDismiss: false
  }, iOSPWAPromptProps)));
}

module.exports = exports.default;